/* eslint-disable no-nested-ternary */
import React, { useCallback, useState } from "react";
import { Skeleton } from "@mui/material";
import SelectComponent from "components/selectAutoCompleteG";
import SelectComponentMultiple from "components/SelectAutoCompleteMultipleG";
import { PrimaryButton } from "screens/perfilAutonomo/components/primaryButton.component";
import CheckboxComponent from "components/CheckBoxG";
import { RevendaComponentProps } from "screens/revenda/utils";
import { toast } from "react-toastify";
import { Loading } from "screens/perfilAutonomo/components/Loading";
import { debounce } from "screens/perfilAutonomo/utils";
import * as S from "./style";
import { FooterTableEmpreendimentosRevenda } from "../FooterTable";
import { defaultTransferenciaData } from "./utils";
import { putTransferirRevenda } from "./api/putTransferirRevenda";
import { fetchResponsaveisDe } from "./api/postResponsaveisDe";
import { postResponsaveisPara } from "./api/postResponsaveisPara";
import { postEmpreendimentosAutonomo } from "./api/postEmpAutonomo";
import { postUnidadeAutonomo } from "./api/postUnidadeAutonomo";

export const TransferenciaRevendaComponent: React.FC<RevendaComponentProps> = ({
  authToken,
}) => {
  const [data, setData] = useState(defaultTransferenciaData);
  const [list, setList] = useState<any[]>([]);

  const [responsaveisParaOptions, setResponsaveisParaOptions] = useState<any[]>(
    []
  );
  const [loadingResponsaveisPara, setLoadingResponsaveisPara] = useState(false);
  const [empreendimentosOptions, setEmpreendimentosOptions] = useState<any[]>(
    []
  );
  const [loadingEmpreendimentos, setLoadingEmpreendimentos] = useState(false);

  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [pagination, setPagination] = useState({
    paginaAtual: 1,
    totalItensRetorno: 10,
    countTotalPagination: 1,
  });

  const { data: responsaveisDeOptions, loading: loadingResponsaveisDe } =
    fetchResponsaveisDe({ enabled: true, authToken });

  const fetchResponsaveisPara = useCallback(
    debounce((idAutonomoResponsavel: string) => {
      setLoadingResponsaveisPara(true);

      postResponsaveisPara({ authToken, idAutonomoResponsavel })
        .then(({ success, data: res, notifications }) => {
          if (!success) throw new Error(notifications?.[0]?.message ?? "");
          setResponsaveisParaOptions(
            res?.autonomos && res?.autonomos?.length > 0
              ? res?.autonomos?.map((item: any) => ({
                  label: item?.nomeRanking,
                  value: item?.id,
                }))
              : []
          );
        })
        .catch((err) => {
          console.error("Error fetching responsaveis para", err);
          toast.error(
            err?.message
              ? `Erro: ${err?.message}`
              : "Erro ao buscar usuários responsáveis"
          );
        })
        .finally(() => {
          setLoadingResponsaveisPara(false);
        });
    }, 1250),
    []
  );

  const fetchEmpreendimentos = useCallback(
    debounce((idAutonomo: string) => {
      setLoadingEmpreendimentos(true);

      postEmpreendimentosAutonomo({ authToken, idAutonomo })
        .then(({ success, data: res, notifications }) => {
          if (!success) throw new Error(notifications?.[0]?.message ?? "");
          setEmpreendimentosOptions(
            res?.data && res?.data?.length > 0
              ? res?.data?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                }))
              : []
          );
        })
        .catch((err) => {
          console.error("Error fetching empreendimentos", err);
          toast.error(
            err?.message
              ? `Erro: ${err?.message}`
              : "Erro ao buscar empreendimentos"
          );
        })
        .finally(() => {
          setLoadingEmpreendimentos(false);
        });
    }, 1250),
    []
  );

  const fetchList = (_data: {
    idAutonomo: string;
    idsRevendaEmpreendimento: string[];
    registros: number;
    pagina: number;
  }) => {
    if (!_data.idAutonomo) return;

    setLoading(true);

    postUnidadeAutonomo({ ..._data, authToken })
      .then(({ success, data: res, notifications }) => {
        if (!success) throw new Error(notifications?.[0]?.message ?? "");
        setPagination((prev) => ({
          ...prev,
          countTotalPagination: Math.ceil(
            (res?.totalRegistros || 0) / res?.registros
          ),
        }));
        setList(res?.response);
      })
      .catch((err) => {
        console.error("Error fetching equipes", err);
        toast.error(
          err?.message ? `Erro: ${err?.message}` : "Erro ao buscar equipes"
        );
        setList([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchListDebounced = useCallback(debounce(fetchList, 1250), []);

  const handleSubmit = () => {
    setSubmitting(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { empreendimentos, ..._data } = data;

    putTransferirRevenda({ authToken, ..._data })
      .then(({ success, notifications }) => {
        if (!success) throw new Error(notifications?.[0]?.message ?? "");
        toast.success("Transferência realizada com sucesso");
        setData((prev) => {
          const _d = {
            ...defaultTransferenciaData,
            idAutonomoDe: prev.idAutonomoDe,
          };
          fetchList({
            idAutonomo: prev.idAutonomoDe,
            idsRevendaEmpreendimento: [],
            registros: pagination.totalItensRetorno ?? 10,
            pagina: pagination.paginaAtual ?? 1,
          });
          return _d;
        });
      })
      .catch((err) => {
        console.error("Error submitting transferência", err);
        toast.error(
          err?.message
            ? `Erro: ${err?.message}`
            : "Erro ao realizar transferência"
        );
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const canSubmit =
    data.idAutonomoDe &&
    data.idAutonomoPara &&
    data.idsRevendaUnidade.length > 0;

  return (
    <S.Container>
      <h2 style={{ fontSize: 16 }}>
        {"Selecione abaixo para carregar a lista de empreendimentos"}
      </h2>

      <S.Row>
        <S.Field>
          <p className="label">
            {"Usuário responsável de:"}
            {loadingResponsaveisDe && <Loading fit size={14} />}
          </p>
          <SelectComponent
            data={
              responsaveisDeOptions
                ? responsaveisDeOptions?.map((item: any) => ({
                    label: item?.nomeRanking,
                    value: item?.id,
                  }))
                : []
            }
            onChange={(e: { label: string; value: string }) => {
              setData(() => {
                const _d = {
                  ...defaultTransferenciaData,
                  idAutonomoDe: e?.value ?? "",
                };
                setList([]);
                fetchList({
                  idAutonomo: e?.value ?? "",
                  idsRevendaEmpreendimento: [],
                  registros: pagination.totalItensRetorno || 10,
                  pagina: pagination.paginaAtual || 1,
                });
                if (e?.value) {
                  fetchResponsaveisPara(e.value);
                  fetchEmpreendimentos(e.value);
                } else {
                  setResponsaveisParaOptions([]);
                  setEmpreendimentosOptions([]);
                }
                return _d;
              });
            }}
            value={
              responsaveisDeOptions
                ?.map((item: any) => ({
                  label: item?.nomeRanking,
                  value: item?.id,
                }))
                ?.find((item: any) => item?.value === data.idAutonomoDe) ?? ""
            }
            disabled={
              loadingResponsaveisDe || responsaveisDeOptions?.length === 0
            }
          />
        </S.Field>
        <S.Field>
          <p className="label">
            {"Empreendimentos"}
            {loadingEmpreendimentos && <Loading fit size={14} />}
          </p>
          <SelectComponentMultiple
            data={empreendimentosOptions}
            onChange={(ev: any, val: any) => {
              setData((prev) => {
                const _d = { ...prev, empreendimentos: val };
                fetchListDebounced({
                  idAutonomo: prev.idAutonomoDe,
                  idsRevendaEmpreendimento: val?.map(
                    (item: any) => item?.value
                  ),
                  registros: pagination.totalItensRetorno || 10,
                  pagina: pagination.paginaAtual || 1,
                });
                return _d;
              });
            }}
            value={data.empreendimentos}
            isMultiple
            label=""
            placeholder={
              empreendimentosOptions?.length > 0
                ? ""
                : "Nenhum empreendimento encontrado"
            }
            disabled={
              loadingEmpreendimentos ||
              empreendimentosOptions?.length === 0 ||
              !data.idAutonomoDe
            }
          />
        </S.Field>
      </S.Row>

      <S.Table>
        <S.Content>
          <S.TableContainer>
            <S.TableBody>
              <S.TableHeader>
                <p>{""}</p>
                <p>{"Empreendimento"}</p>
                <p>{"Torre"}</p>
                <p>{"Unidade"}</p>
                <p>{"Usuário Responsável"}</p>
              </S.TableHeader>

              <S.TableContent>
                {loading ? (
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: 6 }}
                  >
                    {[0, 1, 2, 3, 4].map((item) => (
                      <Skeleton
                        key={item}
                        variant="rectangular"
                        height={38}
                        width="100%"
                      />
                    ))}
                  </div>
                ) : list?.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      padding: 16,
                      justifyContent: "center",
                    }}
                  >
                    <p>{"Nenhum empreendimento encontrado"}</p>
                  </div>
                ) : (
                  list?.map((item, index) => (
                    <S.TableItem
                      key={item?.id}
                      first={index === 0}
                      background={index % 2 === 0 ? "#fbfcff" : "white"}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          paddingRight: 10,
                        }}
                      >
                        <CheckboxComponent
                          label=""
                          onChange={() => {
                            if (data.idsRevendaUnidade?.includes(item?.id)) {
                              setData((prev) => ({
                                ...prev,
                                idsRevendaUnidade:
                                  prev?.idsRevendaUnidade?.filter(
                                    (id) => id !== item?.id
                                  ),
                              }));
                            } else {
                              setData((prev) => ({
                                ...prev,
                                idsRevendaUnidade: [
                                  ...prev?.idsRevendaUnidade,
                                  item?.id,
                                ],
                              }));
                            }
                          }}
                          checked={data.idsRevendaUnidade?.includes(item?.id)}
                          removePadding
                        />
                      </div>
                      <p>{item?.revendaEmpreendimento?.nome ?? "--"}</p>
                      <p>
                        {item?.revendaEmpreendimentoTorre?.descricao ?? "--"}
                      </p>
                      <p>{item?.unidade ?? "--"}</p>
                      <p>{item?.usuarioResponsavel ?? "--"}</p>
                    </S.TableItem>
                  ))
                )}
              </S.TableContent>
            </S.TableBody>
          </S.TableContainer>
        </S.Content>

        <FooterTableEmpreendimentosRevenda
          onData={(d) => {
            setPagination((prev) => {
              const _d = {
                ...prev,
                paginaAtual: d.PaginaAtual || 1,
                totalItensRetorno: d.TotalItensRetorno || 10,
              };
              fetchList({
                idAutonomo: data.idAutonomoDe,
                idsRevendaEmpreendimento: data.empreendimentos?.map(
                  (item: any) => item?.value
                ),
                registros: d.TotalItensRetorno || 10,
                pagina: d.PaginaAtual || 1,
              });
              return _d;
            });
          }}
          PaginaAtual={pagination.paginaAtual}
          TotalItensRetorno={pagination.totalItensRetorno}
          countTotalPagination={pagination.countTotalPagination}
        />
      </S.Table>

      <S.Row style={{ alignItems: "flex-end" }}>
        <S.Field>
          <p className="label">
            {"Usuário responsável para:"}
            {loadingResponsaveisPara && <Loading fit size={14} />}
          </p>
          <SelectComponent
            data={responsaveisParaOptions}
            onChange={(e: { label: string; value: string }) => {
              setData((prev) => ({ ...prev, idAutonomoPara: e?.value ?? "" }));
            }}
            value={
              responsaveisParaOptions?.find(
                (item: any) => item?.value === data.idAutonomoPara
              ) ?? ""
            }
            disabled={
              !data.idAutonomoDe ||
              loadingResponsaveisPara ||
              responsaveisParaOptions?.length === 0
            }
          />
        </S.Field>
        <div style={{ maxWidth: 240 }}>
          <PrimaryButton
            content={
              submitting ? <Loading size={20} color="white" /> : "Transferir"
            }
            onClick={handleSubmit}
            disabled={submitting || !canSubmit}
          />
        </div>
      </S.Row>
    </S.Container>
  );
};
